import { useNavigate } from 'react-router-dom';
import { Button } from '@/core/components/ui/button';

/**
 * AuthErrorScreen - Atomic Component
 * Displays authentication error with manual login option
 */
export const AuthErrorScreen = () => {
  const navigate = useNavigate();
  
  const handleManualLogin = () => {
    console.log('Manual Login button clicked, navigating to /login');
    navigate('/login');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="bg-red-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Authentication Required</h2>
        <p className="text-gray-600 mb-4">Unable to verify your credentials automatically.</p>
        <p className="text-sm text-gray-500 mb-6">
          Please use the manual login option below or ensure you're accessing this application through the authorized portal.
        </p>
        <Button
          onClick={handleManualLogin}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          Manual Login
        </Button>
      </div>
    </div>
  );
};
